


























































































































































import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as activity from "../../_store/activity.module";
import * as auth from "../../_store/auth.module";
import { userUtils } from "../../_utils/userUtils";
import { bus } from "../../main";
import { Activities } from "../../_models/activities";
import CardTitle from "../../components/CardTitle.vue";
import { IscrizioneAzienda } from "../../_models/iscrizioneAzienda";
import { router } from "../../_router";
import * as data from "../../_store/data.module";
import { StudentInfo } from "../../_models/studentInfo";
import * as temp from "../../_store/temp.module";
import QuestionarioDialog from "../../components/Dialogs/QuestionarioDialog.vue";
// import { nextTick } from "process";

@Component({
  components: {
    CardTitle,
    QuestionarioDialog
  }
})
export default class IscrizioniAttivitaAllievo extends Vue {
  private statusIscrizione: any[];
  private titleParams: object;
  private isComplete: boolean;

  private listaAttivita: any;
  private gruppiAttivita: any;
  private lastYear: number;
  private currentYear: number;
  private annoStudente: number;
  private infoWorkshop: any;
  private titleWorkshop: any;
  private showDialog: boolean;
  private diplomato: boolean;
  private vecchioDiploma: boolean;

  constructor() {
    super();
    this.titleParams = {
      title: "Attività Istituto",
      cols: "12",
      sm: "6",
      md: "5",
      lg: "5"
    };
    this.statusIscrizione = [];
    this.isComplete = false;

    this.listaAttivita = [];
    this.gruppiAttivita = [];
    this.lastYear = 0;
    this.currentYear = 0;
    this.annoStudente = 0;
    this.infoWorkshop = {};
    this.titleWorkshop = {};
    this.showDialog = true;
    this.diplomato = false;
    this.vecchioDiploma = false;
  }

  subscribeToActivity(idAttivita: number) {
    var isComplete: boolean = false;
    var studentInfo = user.readStudentInfo(this["$store"]);
    var payload = {
      idAttivita: idAttivita,
      idAllievo: studentInfo.idUtente
    };
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload2 = {
      idAllievo: studentInfo.idUtente,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: studentInfo.codEntità
    };
    isComplete = userUtils.checkStudentInfo(studentInfo);
    if (isComplete !== false) {
      activity
        .dispatchSubscribeToActivityAllievo(this["$store"], payload)
        .then(result => {
          bus.$emit("successfullOperation", "Iscrizione avvenuta con successo");
          this.listaAttivita = [];
          this.loadActivities(studentInfo.idUtente, studentInfo.codEntità);
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  subscribeToActivityWithCheck(idAttivita: number) {
    var isComplete: boolean = false;
    var studentInfo = user.readStudentInfo(this["$store"]);
    var payload = {
      idAttivita: idAttivita,
      idAllievo: studentInfo.idUtente
    };
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload2 = {
      idAllievo: studentInfo.idUtente,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: studentInfo.codEntità
    };
    isComplete = userUtils.checkStudentInfo(studentInfo);
    if (isComplete !== false) {
      data
        .dispatchCheckPattoCorresponsabilitaAllievo(this["$store"], payload2)
        .then(result => {
          if (result) {
            activity
              .dispatchSubscribeToActivityAllievo(this["$store"], payload)
              .then(result => {
                bus.$emit(
                  "successfullOperation",
                  "Iscrizione avvenuta con successo"
                );
                this.listaAttivita = [];
                this.loadActivities(
                  studentInfo.idUtente,
                  studentInfo.codEntità
                );
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", error.response.statusText);
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", error.response.statusText);
                }
              });
          } else {
            bus.$emit("errorOperation", "Compilare Patto di Corresponsabilità");
          }
        })
        .catch(error => {
          if (error.response.status === 403) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    } else {
      bus.$emit("incompleteInfo");
    }
  }

  loadActivities(idAllievo: number, idIstituto: number) {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idAllievo: idAllievo,
      idAnnoScolastico: idAnnoScolastico,
      idIstituto: idIstituto
    };
    this.listaAttivita = [];
    var listaAttivitaIstituto: any[] = [];
    activity
      .dispatchGetAttivitaIstitutoAllievo(this["$store"], payload)
      .then(result => {
        result.forEach((element: any) => {
          if (!this.gruppiAttivita.includes(element.idTipoAttivita)) {
            this.gruppiAttivita.push(element.idTipoAttivita);
          }
        });
        this.gruppiAttivita.forEach((att: any) => {
          var attivitaElem = {
            idTipoAttivita: 0,
            nomeTipoAttivita: "",
            attivitaIstituto: []
          };
          attivitaElem.idTipoAttivita = att;
          result.forEach((attivita: any) => {
            if (attivita.idTipoAttivita === attivitaElem.idTipoAttivita) {
              attivitaElem.nomeTipoAttivita = attivita.idTipoAttivita;
              attivitaElem.attivitaIstituto.push({
                //@ts-ignore
                idIscrizione: attivita.idIscrizione,
                //@ts-ignore
                idAttivitaIstituto: attivita.idAttivitaIstituto,
                //@ts-ignore
                idAnnoScolastico: attivita.idAnnoScolastico,
                //@ts-ignore
                idAzienda: attivita.idAzienda,
                //@ts-ignore
                dataIscrizione: attivita.dataIscrizione,
                //@ts-ignore
                dataInizio: attivita.dataInizio,
                //@ts-ignore
                dataFine: attivita.dataFine,
                //@ts-ignore
                idTipoAttivita: attivita.idTipoAttivita,
                //@ts-ignore
                nomeAttivita: attivita.nomeAttivita,
                //@ts-ignore
                statoPeriodoIscrizione: attivita.statoPeriodoIscrizione
              });
            }
            if (attivita.idTipoAttivita === 5) {
              this.infoWorkshop = {
                idRichiesta: attivita.idIscrizione,
                dataFineAttivita: attivita.dataFine
              };
              this.titleWorkshop = {
                title: "QUESTIONARIO WORKSHOP"
              };
            }
          });
          listaAttivitaIstituto.push(attivitaElem);
        });
        this.listaAttivita = listaAttivitaIstituto;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  async lastYearSubscription() {
    var studentInfo = user.readStudentInfo(this["$store"]);
    var payload = {
      idAllievo: studentInfo.idUtente
    };
    return new Promise<number>((resolve, reject) => {
      data
        .dispatchLastYearSubscription(this["$store"], payload)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  created() {
    var token = localStorage.getItem("userToken");
    var studentInfo: StudentInfo;
    var parsedToken: any;
    var dataDiploma: any;
    var currentDate: any;
    var tmpDate: any;
    var year: number;
    var month: number;
    var day: number;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetStudentInfo(this["$store"], payload)
      .then(() => {
        bus.$emit("loadMenu");
        studentInfo = user.readStudentInfo(this["$store"]);
        var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
        if (studentInfo.diplomato) {
          this.diplomato = true;
          dataDiploma = new Date(studentInfo.dataDiploma);
          currentDate = new Date();
          // vecchioDiploma 
          year = dataDiploma.getFullYear();
          month = dataDiploma.getMonth();
          day = dataDiploma.getDate();
          tmpDate = new Date(year + 1, month, day)
          if (tmpDate < currentDate) {
            this.vecchioDiploma = true;
          }
        }
        this.lastYearSubscription()
          .then(result => {
            this.annoStudente = parseInt(studentInfo.classe.charAt(0));
            this.lastYear = result;
            this.currentYear = idAnnoScolastico;
            this.loadActivities(studentInfo.idUtente, studentInfo.codEntità);
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadAttivitaIstituto", () => {
      var studentInfo = user.readStudentInfo(this["$store"]);
      this.loadActivities(studentInfo.idUtente, studentInfo.codEntità);
    });
  }
}
